import { render, staticRenderFns } from "./Index-trx.vue?vue&type=template&id=724aa43f&scoped=true"
import script from "./Index-trx.vue?vue&type=script&lang=js"
export * from "./Index-trx.vue?vue&type=script&lang=js"
import style0 from "./Index-trx.vue?vue&type=style&index=0&id=724aa43f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724aa43f",
  null
  
)

export default component.exports